'use client';

import { type Dispatch, type SetStateAction, useEffect } from 'react';

import { trackAnalyticsEvent } from '@/app/lib/analytics';
import { Modal } from '@/components/modal';
import { ANALYTICS_EVENTS, BUSINESS_PHONE_NO, RESIDENTIAL_SERVICE_PHONE_NO } from '@/constants';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

import { Button } from '../button';
import { Text } from '../text';


type GasAddressNotFoundModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  remainOnPage?: boolean;
};

export const GasAddressNotFoundModal = ({
  isModalOpen = false,
  setIsModalOpen,
}: GasAddressNotFoundModalProps) => {
  const { resetJoinFormStore } = useJoinFormStore();

  function cancelModal() {
    resetJoinFormStore();
    setIsModalOpen(false);
    trackAnalyticsEvent(ANALYTICS_EVENTS.addressNotFoundModal.modalClose, {});
  }

  function openModal() {
    setIsModalOpen(true);
  }

  useEffect(() => {
    if (isModalOpen) {
      trackAnalyticsEvent(ANALYTICS_EVENTS.addressNotFoundModal.modalOpen, {});
    }
  }, [isModalOpen]);

  return (
    <Modal
      heading="Sorry we couldn’t find your address"
      description="Sometimes its easier to talk to a person. We’re available between
            8am - 7pm, Monday - Friday (AET)"
      isModalOpen={isModalOpen}
      closeModal={cancelModal}
      openModal={openModal}
    >
      <div className="flex grow flex-col gap-e overflow-y-auto p-e md:gap-d lg:p-d ">
        <div className="flex gap-c">
          <div className="flex flex-1 flex-col gap-a">
            <Text variant="body2">Residential</Text>
            <Button
              icon="phone"
              iconPosition="left"
              variant="secondary"
              href={`tel:${RESIDENTIAL_SERVICE_PHONE_NO}`}
              onClick={() => trackAnalyticsEvent(ANALYTICS_EVENTS.addressNotFoundModal.callResidential, {})}
            >
              {RESIDENTIAL_SERVICE_PHONE_NO}
            </Button>
          </div>
          <div className="flex flex-1  flex-col gap-a">
            <Text variant="body2">Business</Text>
            <Button
              icon="phone"
              iconPosition="left"
              href={`tel:${BUSINESS_PHONE_NO}`}
              variant="secondary"
              onClick={() => trackAnalyticsEvent(ANALYTICS_EVENTS.addressNotFoundModal.callBusiness, {})}
            >
              1800 728 197
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
